"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToothBrush = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ToothBrush = function ToothBrush(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.251 0h-.748v1.817c0 1.283-.126 2.595-.374 3.84a19.803 19.803 0 00-.375 3.836v5.57c0 .517.336.937.749.937s.748-.42.748-.938V9.495c0-1.282.126-2.595.375-3.839A19.83 19.83 0 005 1.817v-.88C5 .421 4.664 0 4.251 0zM1.5 0a.5.5 0 00-.5.5V2h1.997c0-.02.003-.041.003-.062V0H1.5zM1 3v1.508c0 .272.23.492.514.492H2.74c.135-.649.211-1.34.259-2H1zm11.5-3h-3a.5.5 0 00-.5.5V2h4V.5a.5.5 0 00-.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.414 3a1 1 0 00-.707.293L7.293 4.707A1 1 0 007 5.414V15a1 1 0 001 1h6a1 1 0 001-1V5.414a1 1 0 00-.293-.707l-1.414-1.414A1 1 0 0012.586 3H9.414zm1.76 3.304L12.6 8.798c.257.454.4 1.013.4 1.577C13 11.822 12.102 13 11 13c-1.103 0-2-1.178-2-2.625 0-.564.143-1.123.4-1.576l1.426-2.495a.2.2 0 01.348 0z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 9.599l-.621-1.241a.2.2 0 00-.358 0L10.2 9.6c-.129.258-.2.578-.2.9 0 .827.449 1.5 1 1.5.551 0 1-.673 1-1.5a2.06 2.06 0 00-.2-.901z",
    fill: "currentColor"
  }));
};

exports.ToothBrush = ToothBrush;
var _default = ToothBrush;
exports.default = _default;